module.exports = __webpack_public_path__ + "img/candidate.37eee58e.svg";